export default __webpack_public_path__ + "static/rec-1998-214a45e0aa2583245998fbea2dff2ab7.png";